addEventListener('turbo:submit-start', () => {
	for (const element of document.querySelectorAll('.disable-on-submit')) {
		element.classList.add('disabled')
	}
})

addEventListener('turbo:submit-end', () => {
	/*
	for (const modal of document.querySelectorAll('.modal.show:not(.ignore-disable-on-submit)')) {
		const modalInstance = bootstrap.Modal.getOrCreateInstance(modal)
		if (modalInstance) modalInstance.modal('hide')
	}
	*/

	for (const element of document.querySelectorAll('.disable-on-submit')) {
		setTimeout( () => {
			if (element) { element.classList.remove('disabled') }
		}, 250)
	}

})

addEventListener('turbo:before-fetch-request', () => {
	for (const element of document.querySelectorAll('.disable-on-submit')) {
		element.classList.add('disabled')
	}
})

addEventListener('turbo:load', () => {
	for (const element of document.querySelectorAll('.disable-on-submit')) {
		setTimeout( () => {
			if (element) { element.classList.remove('disabled') }
		}, 250)
	}

})

addEventListener('turbo:frame-load', () => {
	for (const element of document.querySelectorAll('.disable-on-submit')) {
		setTimeout( () => {
			if (element) { element.classList.remove('disabled') }
		}, 250)
	}

})

addEventListener('turbo:before-stream-render', () => {
	for (const element of document.querySelectorAll('.disable-on-submit')) {
		setTimeout( () => {
			if (element) { element.classList.remove('disabled') }
		}, 250)
	}

})

